
import { CommandType } from "~app/common/services/cqs/CommandType";
import { AvtalCommandBase } from "./AvtalCommandBase";

export class UpdateAvtalKundCommand extends AvtalCommandBase {
    kundId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAvtalKundCommand";

    constructor(avtalGuid: string, kundId: number) {
        super(avtalGuid, UpdateAvtalKundCommand.$type, CommandType.Replace);
        this.kundId = kundId;
    }
}
